import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import BigNumber from 'bignumber.js';

import * as actions from '../actions';
import { MessageType } from '../types';
import { PubnubState } from '..';

export const publishMessageBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.publishMessage.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.publishMessage.fulfilled, (state, action) => {
      if (action.payload.messageType === MessageType.RAISE_HAND) {
        state.currentRaiseHandMsgTT = new BigNumber(action.payload.timeToken).valueOf();
      }

      if (action.payload.messageType === MessageType.REACTION) {
        state.currentReactionMsgTT = new BigNumber(action.payload.timeToken).valueOf();
      }

      state.isBusy = false;
    })
    .addCase(actions.publishMessage.rejected, (state) => {
      state.isBusy = false;
    });
};
